// Every API route the web app calls, in one place, so a rename on the API side
// is a one-line change here. The fixture server answers the same paths.
import type { Day, Half } from "../lib/types";

const q = (o: Record<string, string | number | null | undefined>) => {
  const s = new URLSearchParams();
  for (const [k, v] of Object.entries(o)) if (v != null && v !== "") s.set(k, String(v));
  const t = s.toString();
  return t ? `?${t}` : "";
};

export const paths = {
  me: () => "/api/me",
  week: (weekStart: Day | "current", version?: number | null) => `/api/weeks/${weekStart}${q({ version })}`,
  check: (weekStart: Day) => `/api/weeks/${weekStart}/check`,
  saveVersion: (weekStart: Day) => `/api/weeks/${weekStart}/versions`,
  approve: (weekStart: Day) => `/api/weeks/${weekStart}/approve`,
  replan: (weekStart: Day) => `/api/weeks/${weekStart}/replan`,
  bench: (person?: string | null, day?: Day | null, half?: Half | null) => `/api/bench${q({ person, day, half })}`,
  sessions: () => "/api/sessions",
  startSession: () => "/api/sessions/start",
  undoSession: (id: number) => `/api/sessions/${id}/undo`,
  shelves: () => "/api/shelves",
  counts: () => "/api/stock/counts",
  stockEvents: (shelf?: string | null) => `/api/stock/events${q({ shelf })}`,
  shelf: (code: string) => `/api/shelves/${encodeURIComponent(code)}`,
  raw: () => "/api/raw",
  tasks: () => "/api/tasks",
  stations: () => "/api/stations",
  cures: () => "/api/cures",
  people: () => "/api/people",
  person: (id: number) => `/api/people/${id}`,
  skills: () => "/api/skills",
  acknowledgeSkill: () => "/api/skills/acknowledge",
  stats: (from?: Day, to?: Day) => `/api/stats${q({ from, to })}`,
  review: (weekStart?: Day | null) => `/api/review${q({ week: weekStart })}`,
  changes: (since: number) => `/api/changes${q({ since })}`,
  requests: () => "/api/requests",
  planDoesntWork: () => "/api/requests/plan-doesnt-work",
  settings: () => "/api/settings",
  setting: (key: string) => `/api/settings/${encodeURIComponent(key)}`,
  board: () => "/api/board"
};
